import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { MANAGE_OFFERS_LISTING_KEY } from '@steelbuy/data-access';
import { CreateListingContextProvider } from '../../components/create-listing/CreateListingContext';
import { ManageOffersContextProvider } from '../../components/manage-offers/ManageOffersContext';

export const ManageOffersView = () => {
    const queryClient = useQueryClient();

    useEffect(
        () => () => {
            queryClient.removeQueries({ queryKey: [MANAGE_OFFERS_LISTING_KEY] });
        },
        []
    );

    return (
        <ManageOffersContextProvider>
            <CreateListingContextProvider>
                <Outlet />
            </CreateListingContextProvider>
        </ManageOffersContextProvider>
    );
};
